import { forwardRef, type SVGProps } from 'react';

export type EditProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const Edit = forwardRef<SVGSVGElement, EditProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M13 26l-9 2 2.2-8.6 14-14a4.6 4.6 0 016.5 0h0a4.6 4.6 0 010 6.5zm5-18.5l6.5 6.5"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
Edit.displayName = 'Edit';
